export default __webpack_public_path__ + "static/media/pic3.2b5c25d9.jpg";